<template>
    <div>
        <div>
            <div v-if="type == 'button'">
                <select class="form-control" name="variant" v-model="pid" v-if="variants.length > 1">
                    <option v-for="variant in variants" :key="variant.pid" :data-id="variant.pid" :value="variant.pid">{{variant.variant}}</option>
                </select>
                <div class="spacer" v-else></div>
                <br>
                <button @click="submit" :disabled="loading" v-if="pstock != '0' && !added" class="btn btn-primary"><i v-if="!loading" class="icon-cart"></i>
                    in den warenkorb
                    <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                </button>
                <i class="icon-check-mark confirmCartAdd" v-if="added"></i>
                <button v-if="pstock == '0'" class="btn btn-disabled">
                    <slot><i class="icon-cart"></i> in den warenkorb</slot>
                </button>
            </div>
            <div v-if="type == 'detail'">
                <div class="row info">
                    <div class="col-sm-12">
                        Verfügbarkeit: <b>{{ availability }}</b><br>
                        Artikelnummer: <b>{{ model }}</b><br>
                        <template v-if="packagingunit != ''">
                        Verpackungseinheit: {{packagingunitprice}} Stück<br>
                        </template>
                        Preis: <b>€ {{variant.price | money }} exkl. USt</b><br>
                        Verfügbare Menge: <b>{{pstock}} {{ this.selling_unit }} Verpackungseinheit(en)</b><br>
                        
                        <div class="red" v-if="packagingunitprice > 1">Sie bestellen {{ formatQuantity(qty*packagingunitprice) }} Stück</div>
                    </div>
                </div>
                <div class="row" v-show="variants.length > 1">
                    <div class="col-sm-12">
                        <div class="sizeContainer">
                            <table>
                                <tr>
                                    <td class="name">Variant<span>*</span></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <select name="variant" v-model="pid">
                                            <option v-for="variant in variants" :key="variant.pid" :data-id="variant.pid" :value="variant.pid">{{variant.variant}}</option>
                                        </select>
                                    </td>
                                </tr>
                            </table>
                            <div class="required">* Required Fields.</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row addToCartContainer">
                            <div class="col-xs-4 text-center">
                                Menge:
                            </div>
                            <div class="col-xs-4 text-center">
                                <input class="form-control" type="number" value="1" v-model="qty" />
                            </div>
                            <div class="col-xs-4 text-center">
                                <label class="control-label" v-if="packagingunit != ''">Verpackungseinheit(en)</label>
                                <label class="control-label" v-if="packagingunit == ''">Stück</label>                 
                            </div>
                            <div class="col-xs-12 buttonContainer">
                                <button @click="submit" :disabled="loading" v-if="pstock != '0' && !added" class="btn btn-primary"><i class="icon-cart" v-if="!loading"></i><i v-if="loading" class="fa fa-spin fa-spinner"></i>
                                    in den warenkorb
                                </button>
                                <i class="icon-check-mark confirmCartAdd" v-if="added"></i>
                                <button v-if="pstock == '0'" class="btn btn-disabled">
                                    <slot><i class="icon-cart"></i> in den warenkorb</slot>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="type == 'overview'">
                <div class="row">
                    <div class="col-sm-12 col-xs-6">
                        <div class="form-horizontal data-overview">
                            Artikelnummer: <b>{{ model }}</b><br>
                            <template v-if="packagingunit != ''">
                            Verpackungseinheit: {{packagingunitprice}} Stück<br>
                            </template>
                            Preis: <b>€ {{variant.price | money }} inkl. USt</b><br>
                            Verfügbare Menge: <b>{{pstock}} {{ this.selling_unit }} Verpackungseinheit(en)</b><br>

                            <div class="red" v-if="packagingunitprice > 1">Sie bestellen {{ formatQuantity(qty*packagingunitprice) }} Stück</div>
                        </div>
                    </div>                    
                </div>
                <div class="row">
                    <div class="col-sm-12" v-show="variants.length > 1">
                        <div class="form-horizontal">
                            <div class="form-group form-group-sm">
                                <label class="col-xs-4 control-label">Variant:</label>
                                <div class="col-xs-3">
                                    <select class="form-control" name="variant" v-model="pid">
                                        <option v-for="variant in variants" :key="variant.pid" :data-id="variant.pid" :value="variant.pid">{{variant.variant}}</option>
                                    </select>
                                </div>                         
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="form-horizontal">
                            <div class="form-group form-group-sm">
                                <label class="col-xs-3 control-label">Menge:</label>
                                <div class="col-xs-3 noLeftPadding">
                                    <input class="form-control" type="number" value="1" v-model="qty" />
                                </div>
                                <label class="col-xs-6 control-label" v-if="packagingunit != ''">Verpackungseinheit(en)</label>
                                <label class="col-xs-6 control-label" v-if="packagingunit == ''">Stück</label>                                                
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-10 col-lg-push-1 text-center">
                        <button @click="submit" :disabled="loading" v-if="pstock != '0' && !added" class="btn btn-primary">
                            <slot><i v-if="loading" class="fa fa-spin fa-spinner"></i><i class="icon-cart" v-if="!loading"></i> In den Warenkorb</slot>
                        </button>
                        <i class="icon-check-mark confirmCartAdd" v-if="added"></i>
                        <button v-if="pstock == '0'" class="btn btn-disabled">
                            <slot><i class="icon-cart"></i> In den Warenkorb</slot>
                        </button>
                    </div>
                </div>            
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
      variants: {
        type: [Array],
        default: []
      },
      type: {
        type: [String],
        default: 'overview'
      },
      selling_unit: {
          type: [String],
          default: ''
      },
      in_unit: {
          type: [String, Number],
          default: ''
      },
      smallest_unit: {
          type: [String],
          default: ''
      },
      model: {
          type: [String],
          default: ''
      },
      packageSize: {
          type: [String],
          default: ''
      },
      mainProduct: {
          type: [Number],
          default: 0
      },
      packagingunitprice: {
          type: [String, Number],
          default: ''
      },
      packagingunit: {
          type: [String, Number],
          default: ''
      },
  },

  data() {
      return {
          added: false,
          pid: this.variants[0].pid,
          qty: 1,
          loading: false
      }
  },

  methods: {
      notActive() {
        swal({ 
            html:true, 
            title:'', 
            text:'Dear user,<br><br>You are currently logged-in as a guest user and can therefore only view the articles. Only registered users are able to order.<br><br>Please get in contact with a registered user from your department if you wish to place an order. You can find a list of all registered users <a href="/help/active-user-list">here</a>.<br><br>In case of questions please contact <a href="mailto:b.zbytovsky@triworx.at">b.zbytovsky@triworx.at</a><br>Kind regards,<br>Your Incentive Store team',
            type: "warning"
        });
      },
    
      formatQuantity(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      submit() {

        this.loading = true;

        new Form({
            pid: this.pid,
            qty: this.qty,
            pstock: this.pstock
        })
        .post('/api/cart/add')
        .then((response) => {
            if(response.success) {
                App.event.fire('cart.item.inserted', response.item);
                App.event.fire('cart.updated', response.data);
            } else {
                swal({ 
                    html:true, 
                    title:'', 
                    text: response.error_text,
                    type: "error"
                });
            }

            this.added = true;
            this.loading = false;
            setTimeout(() => {
                this.added = false;
            }, 2000);

        }).catch(errors => {
            this.loading = false;
        });
      }
  },

  computed : {
      variant() {
          return this.variants.filter((item) => {
              return item.pid == this.pid ? true : false;
          }).pop();
      },

      pstock() {
          return this.variant.pstock;
      },

      availability() {
          let stock = parseInt(this.variant.pstock);
          return stock > 0 ? `${stock} ${ this.selling_unit }` : 'Derzeit nicht auf Lager.';
      },

      orderQty() {
          if(this.in_unit < 2) {
              return `1 ${ this.selling_unit }`;
          } else {
              return `1 ${ this.selling_unit } = ${ this.in_unit } ${ this.smallest_unit }`;
          }

      }
  },

  filters: {

      money(value) {
          return parseFloat(value).toFixed(2);
      }

  }
}
</script>
